import React from 'react'
import PropTypes from 'prop-types'
import NumberFormat from 'react-number-format'
import { CopyToClipboard } from 'react-copy-to-clipboard'
import moment from 'moment'
import { snakeToPascalCase } from 'utils/StringFormat'
import Styles from './index.scss'

function formatCurrency(data) {
  return <NumberFormat thousandSeparator displayType="text" value={data} />
}

function formatDate(date) {
  return moment(date).format('DD MMMM YYYY')
}

function isDateFormat(fieldValue) {
  return new Date(fieldValue) !== 'Invalid Date' && !isNaN(new Date(fieldValue))
}

function formatField(field) {
  const data = field.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase())
  return data.replace('_', ' ')
}

function formatStatus(fieldValue, reference) {
  const value = reference.length && reference.filter(r => r.value === fieldValue)[0]
  return <div dangerouslySetInnerHTML={{ __html: value.label || '' }} />
}

function formatData(field, value, additional = []) {
  let fieldValue =
    typeof value !== 'object' &&
    String(value).match(/(https|http)/) &&
    !/<[a-z][\s\S]*>/i.test(value) ? (
      <a href={value} target="_blank" rel="noopener noreferrer">
        {additional.length ? additional : 'View'}
      </a>
    ) : (
      value
    )
  if (/<[a-z][\s\S]*>/i.test(fieldValue)) {
    fieldValue = <div dangerouslySetInnerHTML={{ __html: fieldValue }} /> // eslint-disable-line
  }
  if (typeof fieldValue === 'number') {
    if (field === 'rejectReason') {
      fieldValue = formatStatus(fieldValue, additional)
    } else {
      fieldValue = formatCurrency(fieldValue)
    }
  }
  if (typeof fieldValue === 'boolean') {
    fieldValue = String(fieldValue)
  }
  if (
    isDateFormat(fieldValue) &&
    (field.includes('created') || field.includes('updated') || field.includes('Date')) &&
    typeof fieldValue !== 'boolean'
  ) {
    fieldValue = formatDate(fieldValue)
  }

  if (field === 'paymentMethod') {
    fieldValue = snakeToPascalCase(value)
  }

  return fieldValue
}

const Content = props => {
  const content = props.data
  return (
    <div className={`${Styles['about-text']} portlet light`}>
      <div className="portlet-title">
        <h4>{`${props.title}`}</h4>
      </div>
      <div className="portlet-body">
        <div className="row">
          <div className="table-scrollable table-scrollable-borderless">
            <table className="table table-hover table-light">
              <tbody>
                {content.length &&
                  content.map(c => {
                    let subData = typeof c[1] === 'object' && Object.entries(c[1])
                    const defaultCondition = c[2]
                      ? formatData(c[0], c[1], c[2])
                      : formatData(c[0], c[1])
                    const value =
                      c[0] === 'rejectReason'
                        ? formatData(c[0], c[1], props.reference)
                        : defaultCondition
                    const title =
                      c[0] === 'creativeIdea' ? (
                        <div>
                          {formatField(c[0])}
                          <CopyToClipboard text={c[1].replace(/(<p>|<\/p>|&nbsp;)/g, '')}>
                            <button className={Styles.copyToClipboard}>
                              Copy Project Brief
                            </button>
                          </CopyToClipboard>
                        </div>
                      ) : (
                        formatField(c[0])
                      )

                    if (title === 'Profile' && typeof c[1] === 'object') {
                      subData = subData.filter(data => data[0] === 'profileId')
                    }

                    if (
                      (title === 'Reviewed By' ||
                        title === 'Paid By' ||
                        title === 'Approved By') &&
                      typeof c[1] === 'object'
                    ) {
                      subData = subData.filter(data => data[0] === 'email')
                    }

                    return (
                      <tr key={c[0]}>
                        <td
                          width={props.columnWidth}
                          style={{ textTransform: 'capitalize' }}
                        >
                          {title}
                        </td>
                        <td>
                          {typeof c[1] === 'object' && subData[0] && subData[0].length
                            ? subData[0][1] || 'undefined'
                            : value}
                        </td>
                      </tr>
                    )
                  })}
                {!!(props.orderReference && props.orderReference.length) &&
                  props.orderReference.map((orderRef, i) => (
                    <tr key={orderRef.id}>
                      <td
                        width={props.columnWidth}
                        style={{ textTransform: 'capitalize' }}
                      >
                        Order Reference #{i + 1}
                      </td>
                      <td className={'col-md-3'}>
                        {orderRef.filetype === 'image' ? (
                          <a href={orderRef.urlRawFile}>
                            <img
                              src={`${orderRef.url}`}
                              alt="Order Reference"
                              style={{
                                width: '250px',
                                height: '250px',
                              }}
                            />
                          </a>
                        ) : (
                          <a
                            href={orderRef.urlRawFile}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            Link to reference
                          </a>
                        )}
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
          </div>
        </div>
        {props.action && props.actionOnChange && (
          <form
            onSubmit={props.action(
              props.actionParam.id,
              props.actionParam.selectedValue,
              props.actionParam.orderId,
              props.actionParam.selectedReason,
            )}
          >
            <div className="mt-radio-list">
              <label htmlFor="approve" className="mt-radio mt-radio-outline">
                {' '}
                Approve
                <input
                  onChange={props.actionOnChange(props.actionParam.approvedValue)}
                  required
                  type="radio"
                  value="approved"
                  id="approve"
                  name="status"
                  checked={
                    props.actionParam.selectedValue === props.actionParam.approvedValue
                  }
                />
                <span />
              </label>
              <label htmlFor="reject" className="mt-radio mt-radio-outline">
                {' '}
                Reject
                <input
                  onChange={props.actionOnChange(props.actionParam.rejectedValue)}
                  required
                  type="radio"
                  value="rejected"
                  id="reject"
                  name="status"
                  checked={
                    props.actionParam.selectedValue === props.actionParam.rejectedValue
                  }
                />
                <span />
              </label>
            </div>
            {props.actionParam.selectedValue === props.actionParam.rejectedValue ? (
              <div>
                <p>Select Reason:</p>
                <div className="mt-radio-list">
                  {props.reference.map(reason => (
                    <div key={reason.value}>
                      <label htmlFor="statusReject">
                        <input
                          onChange={props.actionOnChangeReason(reason.value)}
                          required
                          type="radio"
                          value={reason.value}
                          id={reason.value}
                          name="statusReject"
                          checked={props.actionParam.selectedReason === reason.value}
                        />
                        <h9
                          onClick={props.actionOnChangeReason(reason.value)}
                          style={{
                            margin: '20px',
                          }}
                        >
                          {reason.label}
                        </h9>
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            ) : null}
            <div className={Styles['form-actions']}>
              <div className="row" style={{ marginLeft: '10px' }}>
                {(props.actionParam.selectedValue === props.actionParam.rejectedValue &&
                  props.actionParam.selectedReason === -1) ||
                props.actionParam.selectedValue === -1 ? (
                  <button type="submit" name="submit" disabled className="btn green">
                    Submit
                  </button>
                ) : (
                  <button type="submit" name="submit" className="btn green">
                    Submit
                  </button>
                )}
              </div>
            </div>
          </form>
        )}
        {props.action && !props.actionOnChange && (
          <div className="row">
            <button
              type="button"
              className="btn green"
              onClick={props.action(
                props.actionParam.id,
                props.actionParam.approvedValue,
                props.actionParam.orderId,
              )}
            >
              Approve
            </button>
            &ensp;
            <button
              type="button"
              className="btn red"
              onClick={props.action(
                props.actionParam.id,
                props.actionParam.rejectedValue,
                props.actionParam.orderId,
              )}
            >
              Reject
            </button>
          </div>
        )}
      </div>
    </div>
  )
}

Content.defaultProps = {
  action: null,
  actionParam: {
    orderId: '',
  },
  reference: [],
  columnWidth: '400',
}

Content.propTypes = {
  data: PropTypes.arrayOf(PropTypes.array).isRequired,
  title: PropTypes.string.isRequired,
  action: PropTypes.func,
  actionOnChange: PropTypes.func,
  actionOnChangeReason: PropTypes.func,
  actionParam: PropTypes.shape({
    id: PropTypes.string,
    approvedValue: PropTypes.number,
    rejectedValue: PropTypes.number,
    orderId: PropTypes.string,
    selectedValue: PropTypes.number,
    selectedReason: PropTypes.number,
  }),
  // columnWidth: PropTypes.string,
  reference: PropTypes.arrayOf(PropTypes.object),
  orderReference: PropTypes.arrayOf(PropTypes.object),
}

export default Content
